<!-- vizbi.org/#pre-register (old links): "Redirecting…" on the shared dialog while the browser
     goes to the fullstack's #pre-register, signed in there too (2026-10-23, from
     ModalDialog/PreRegister.vue, which went to the fullstack's home page, not #pre-register) -->
<template>
  <AppModalDialog hash="pre-register" no-close-button>
    <AppFormWrapper>
      <h2>Pre-registration</h2>
      <p>Redirecting…</p>
    </AppFormWrapper>
  </AppModalDialog>
</template>

<script setup>
import {watch} from "vue";
import {useRoute} from "vue-router";
import AppModalDialog from "@/components/App/Modal/Dialog/index";
import AppFormWrapper from "@/components/App/Form/Wrapper";
import {getFullstackUrl} from "@/composables/useFullstackUrl";
import {getUrlWithAuth} from "@/composables/useUrlWithAuth";

const route = useRoute();

function redirectToFullstack(hash) {
  if (hash !== "#pre-register") return;
  const url = getFullstackUrl()?.replace(/\/+$/, "");
  if (url) window.location.assign(getUrlWithAuth(`${url}/#pre-register`));
}

watch(() => route.hash, redirectToFullstack, {immediate: true});
</script>
